// extracted by mini-css-extract-plugin
export default {"actions":"earning_actions__+cu1+","title":"earning_title__Eko9X","block":"earning_block__rJHbu","subtitle":"earning_subtitle__ROWPH","text":"earning_text__3F5cP"};